import React, { useState, useEffect } from "react";
import DatePicker from "react-datepicker";
import { useDispatch, useSelector } from "react-redux";
import "./NewHire.css";
import Navbar from "../Navbar/Navbar";
import { format, parse } from "date-fns";
import { useLocation, useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import {
  approveNewhire,
  downloadOfferFile,
  generateOffer,
  getofferDetails,
  getRoleList,
  getUserByLoginId,
  initiateNewhire,
  updateUserOnboarding,
  getDesignation,
  validateUser,
  createUser,
  getNewHireTransByLoginId,
  getPersonalDetails,
  getFamilyDetails,
  getEducationDetails,
  getExperienceDetails,
  getUserDocumentDetails,
} from "../../Redux/NewHire/Action";
import { empList } from "../../Redux/DailyUpdateApproval/Action";
import { FaDownload, FaEdit } from "react-icons/fa";
import { ONBOARD_USER_DETAILS, EMP_USER_DETAILS } from "../../Redux/NewHire/ActionType";
import Icon from "../utility/Icon";
import { FaFilePdf } from "react-icons/fa6";
import { UseGeneratePDF } from "../Employee/UseGeneratePDF";
import { fetchClientDetails } from "../../Redux/Config/Action";



const OnBoarding = () => {
  const location = useLocation();
  const { rowData } = location.state || {};
  const token = localStorage.getItem("token");
  const loginId = localStorage.getItem("loginId");
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { emplists } = useSelector((store) => store.dailyUpdateApprover);
  const { onBoardUserDetails, offerDetails, rolelists, empUserDetails, desiglist, validationStatus, field, statusDesc, newHireTransactionList,
    personalDetails, familyListDetails, educationListDetails, experienceListDetails, userdocslist, } = useSelector(
      (store) => store.newHireData
    );


  const { clientDetails } = useSelector((store) => store.config);
  const [joiningDate, setJoiningDate] = useState("");
  const [offerLetter, setOfferLetter] = useState(null);
  const [isDataExists, setIsDataExists] = useState(false);
  const [editMode, setEditMode] = useState(false);
  const [isEditing, setIsEditing] = useState(false);
  const [editData, setEditData] = useState(null);
  const [offerid, setOfferid] = useState("");
  const [customRowData, setCustomRowData] = useState(rowData || {});
  const [show, setShow] = useState(false);
  const [roleModal, setRoleModal] = useState(false);
  const [selectedRoleName, setSelectedRoleName] = useState("");
  const { generatePDF } = UseGeneratePDF();
  const [userdesignation, setUserdesignation] = useState("");
  const [generatePdfFlag, setGeneratePdfFlag] = useState(false);

  const [activeStep, setActiveStep] = useState(1);
  const [emailValidationMessage, setEmailValidationMessage] = useState("");
  const [panValidationMessage, setPanValidationMessage] = useState("");
  const [submitEnabled, setSubmitEnabled] = useState(false);

  const handleStepClick = (step) => {
    setActiveStep(step);
  };

  useEffect(() => {
    dispatch(empList(token, "All"));
    dispatch(getNewHireTransByLoginId(rowData.loginId, token));
  }, [dispatch, token]);

  useEffect(() => {
    if (rowData?.status === "I" || rowData?.status === "A") handleStepClick(2);
    if (rowData.loginId) {
      dispatch(getUserByLoginId(rowData.loginId, token, ONBOARD_USER_DETAILS));
    }
  }, [dispatch, rowData.loginId, token]);

  useEffect(() => {
    if (rowData.loginId) {
      dispatch(getofferDetails(rowData.loginId, token));
    }
  }, [dispatch, rowData.loginId, token]);

  useEffect(() => {
    dispatch(getDesignation(token));
    dispatch(getRoleList(token));
  }, [dispatch, token]);

  const formatDate = (dateString) => {
    if (!dateString) return '-';
    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();
    return `${day}-${month}-${year}`;
  };

  const [onboardData, setOnboardData] = useState({
    joiningDate: "",
    empId: "",
    officeEmail: "",
    managerId: "",
    hrId: "",
    userId: rowData.loginId,
  });

  useEffect(() => {
    if (
      onBoardUserDetails.empId &&
      onBoardUserDetails.hrId &&
      onBoardUserDetails.managerId &&
      onBoardUserDetails.officeEmail
    ) {
      setOnboardData((prevData) => ({
        ...prevData,
        joiningDate: onBoardUserDetails.joiningDate || "",
        empId: onBoardUserDetails.empId || "",
        officeEmail: onBoardUserDetails.officeEmail || "",
        managerId: onBoardUserDetails.managerId || "",
        hrId: onBoardUserDetails.hrId || "",
        userId: onBoardUserDetails.loginId || prevData.userId,
      }));
      setIsDataExists(true);
      handleStepClick(3);
    } else {
      setIsDataExists(false);
    }
  }, [onBoardUserDetails]);

  useEffect(() => {
    if (offerDetails && offerDetails.offerId) {
      setIsEditing(true);
      setOfferid(offerDetails.offerId);
      if (offerDetails?.status === "Offer Accepted") {
        handleStepClick(3);
      } else {
        handleStepClick(2);
      }

    } else {
      setIsEditing(false);
      if (rowData?.status === "I" || rowData?.status === "A") handleStepClick(2);
      else handleStepClick(1);
    }
  }, [offerDetails]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    const intiatorId = loginId;
    const userloginId = rowData.loginId;
    const result = await Swal.fire({
      title: "Are you sure?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, submit it!",
      cancelButtonText: "No, cancel",
    });
    if (result.isConfirmed) {
      Swal.fire({
        title: "Initiating...",
        text: "Please wait while we process your request.",
        allowOutsideClick: false,
        didOpen: () => {
          Swal.showLoading();
        },
      });
      dispatch(initiateNewhire(userloginId, intiatorId, token))
        .then((response) => {
          if (response.statusCode === "00") {
            Swal.fire({
              title: "Success!",
              text: "Newhire initiated successfully.",
              icon: "success",
              timer: 2000,
              showConfirmButton: false,
            });
            handleStepClick(2);
            setCustomRowData((prev) => ({
              ...prev,
              status: "I",
            }));
            dispatch(getNewHireTransByLoginId(rowData.loginId, token));
          } else {
            Swal.fire({
              title: "Error!",
              text: "Newhire initiate unsuccessfull",
              icon: "error",
              confirmButtonText: "OK",
            });
          }
        })
        .catch(() => {
          Swal.fire({
            title: "Error!",
            text: "There was an error initiating the newhire details.",
            icon: "error",
            confirmButtonText: "OK",
          });
        });
    }
  };

  const handleFileChange = (e) => {
    setOfferLetter(e.target.files[0]);
  };

  const handleOfferSubmit = async (e) => {
    e.preventDefault();
    const intiatorId = loginId;
    const userloginId = rowData.loginId;

    const formData = new FormData();
    formData.append("joiningDate", joiningDate);
    formData.append("file", offerLetter);
    formData.append("userId", userloginId);
    formData.append("offerinitiatorId", intiatorId);

    const actionType = isEditing ? "UPDATE" : "INSERT";
    formData.append("actionType", actionType);
    formData.append("offerId", offerid);

    const result = await Swal.fire({
      title: "Are you sure?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, submit it!",
      cancelButtonText: "No, cancel",
    });
    if (result.isConfirmed) {
      Swal.fire({
        title: "Generating...",
        text: "Please wait while we process your request.",
        allowOutsideClick: false,
        didOpen: () => {
          Swal.showLoading();
        },
      });
      dispatch(generateOffer(formData, token))
        .then((response) => {
          if (response.statusCode === "00") {
            dispatch(getofferDetails(rowData.loginId, token));
            setIsEditing(true);
            setEditData(false);
            Swal.fire({
              title: "Success!",
              text: "Offer generated successfully.",
              icon: "success",
              timer: 2000,
              showConfirmButton: false,
            });
          } else {
            Swal.fire({
              title: "Error!",
              text: "Offer generate unsuccessfull",
              icon: "error",
              confirmButtonText: "OK",
            });
          }
        })
        .catch(() => {
          Swal.fire({
            title: "Error!",
            text: "There was an error generating the offer details.",
            icon: "error",
            confirmButtonText: "OK",
          });
        });
    }
  };

  const handleInputChange = (e) => {
    const { id, value } = e.target;
    setOnboardData((prevData) => ({
      ...prevData,
      [id]: value,
    }));
  };

  const handleModifyClick = () => {
    setEditMode(true);
  };

  const handleCancelClick = () => {
    setEditMode(false);
  };

  const handleOfferModifyClick = () => {
    const parsed = parse(offerDetails.joiningDate, "dd-MM-yyyy", new Date());
    setJoiningDate(format(parsed, "yyyy-MM-dd"));
    setEditData(true);
  };

  const handleOfferCancelClick = () => {
    setEditData(false);
  };

  const handleOnboardSubmit = async (e) => {
    e.preventDefault();
    const result = await Swal.fire({
      title: "Are you sure?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, submit it!",
      cancelButtonText: "No, cancel",
    });
    if (result.isConfirmed) {
      dispatch(updateUserOnboarding(onboardData, token))
        .then((response) => {
          if (response.statusCode === "00") {
            setEditMode(false);
            setIsDataExists(true);
            Swal.fire({
              title: "Success!",
              text: "Onboard details submitted successfully.",
              icon: "success",
              timer: 2000,
              showConfirmButton: false,
            });
          } else {
            Swal.fire({
              title: "Error!",
              text: "Onboard submit unsuccessfull",
              icon: "error",
              confirmButtonText: "OK",
            });
          }
        })
        .catch(() => {
          Swal.fire({
            title: "Error!",
            text: "There was an error submitting the onboard details.",
            icon: "error",
            confirmButtonText: "OK",
          });
        });
    }
  };

  const handleDownload = (fileName, loginId) => {
    dispatch(downloadOfferFile(loginId, fileName, token));
  };

  const viewModal = (e) => {
    e.preventDefault();
    setRoleModal(true);
    // handleApprove(e);

  }

  const handleCloseRoleModal = () => {
    setRoleModal(false);
    setSelectedRoleName("");
  };

  const handleApprove = (e) => {
    e.preventDefault();
    Swal.fire({
      title: "Are you sure?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, submit it!",
      cancelButtonText: "No, cancel",
    }).then((result) => {
      if (result.isConfirmed) {
        Swal.fire({
          title: "Generating...",
          text: "Please wait while we process your request.",
          allowOutsideClick: false,
          didOpen: () => {
            Swal.showLoading();
          },
        });
        dispatch(approveNewhire(onBoardUserDetails?.loginId, selectedRoleName, token))
          .then(({ success, error }) => {
            if (success) {
              Swal.fire({
                icon: "success",
                title: "Success",
                text: `NewHire approved successfully!`,
                timer: 2000,
                showConfirmButton: false,
              }).then(() => {
                if (selectedRoleName === 'ROLE_EMP') {
                  navigate("/employee");
                } else if (selectedRoleName === 'ROLE_SUPPORT') {
                  navigate("/supportEmployee");
                } else {
                  navigate("/contractEmployee");
                }
              });
            } else {
              Swal.fire({
                title: "Error!",
                text: error || "There was an error approving the newhire.",
                icon: "error",
                confirmButtonText: "OK",
              });
            }
          })
          .catch(() => {
            Swal.fire({
              title: "Error!",
              text: "There was an error approving the newhire.",
              icon: "error",
              confirmButtonText: "OK",
            });
          });
      }
    });
  };


  const Tooltip = ({ text, children }) => {
    return (
      <div className="tooltip-container">
        {children}
        <div className="tooltip">{text}</div>
      </div>
    );
  }

  const handleDateChange = (date, name) => {
    setUserData((prevData) => ({
      ...prevData,
      [name]: date ? format(date, "yyyy-MM-dd") : "",
    }));
  };

  const [userData, setUserData] = useState({
    userId: "",
    firstName: "",
    lastName: "",
    personalEmail: "",
    dateOfBirth: "",
    pan: "",
    role: "",
    designation: "",
    actionType: "UPDATE",
  });

  const handleClose = () => {
    clearUserInputFields();
    setShow(false);
  };

  const clearUserInputFields = () => {
    setUserData([
      {
        userId: "",
        firstName: "",
        lastName: "",
        personalEmail: "",
        dateOfBirth: "",
        pan: "",
        role: "",
        designation: "",
        actionType: "",
      },
    ]);
  };

  const handleEditUser = () => {
    dispatch(getUserByLoginId(rowData.loginId, token, EMP_USER_DETAILS));
    setShow(true);
  };

  useEffect(() => {
    if (empUserDetails) {
      const matchedRole = rolelists.find(
        (role) => role.roleName === empUserDetails.role
      );
      setUserData({
        userId: empUserDetails.loginId || "",
        firstName: empUserDetails.firstName || "",
        lastName: empUserDetails.lastName || "",
        personalEmail: empUserDetails.personalEmail || "",
        dateOfBirth: empUserDetails.dob || "",
        pan: empUserDetails.pan || "",
        role: matchedRole ? matchedRole.roleId : "",
        designation: empUserDetails.designationId
          ? empUserDetails.designationId
          : "",
        actionType: "UPDATE",
      });
    }
  }, [empUserDetails, rolelists]);

  useEffect(() => {
    if (userData.actionType === "UPDATE") {
      setSubmitEnabled(true);
    }
    if (field === "personalEmail") {
      if (validationStatus === "99") {
        setEmailValidationMessage(statusDesc);
        setSubmitEnabled(false);
      } else if (validationStatus === "00") {
        setEmailValidationMessage("");
        setSubmitEnabled(true);
      }
    }
    if (field === "pan") {
      if (validationStatus === "99") {
        setPanValidationMessage(statusDesc);
        setSubmitEnabled(false);
      } else if (validationStatus === "00") {
        setPanValidationMessage("");
        setSubmitEnabled(true);
      }
    }
  }, [validationStatus, statusDesc, field, userData.actionType]);

  const handleChange = (e) => {
    const { name, value } = e.target;

    if (value && /^[\s]/.test(value)) {
      e.preventDefault();
      return;
    }
    if (
      (name === "firstName" || name === "lastName") &&
      /[^a-zA-Z\s]/.test(value)
    ) {
      e.preventDefault();
      return;
    }

    setUserData((prevData) => ({
      ...prevData,
      [name]: name === "pan" ? value.toUpperCase() : value,
    }));

    if (name === "personalEmail" || name === "pan") {
      dispatch(validateUser({ ...userData, [name]: value }, name, token));
    }
  };

  const handleUserEditSubmit = async (e) => {
    e.preventDefault();
    const result = await Swal.fire({
      title: "Are you sure?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, submit it!",
      cancelButtonText: "No, cancel",
    });
    if (result.isConfirmed) {
      dispatch(createUser(userData, token))
        .then(({ response }) => {
          if (response.statusMessage === "SUCCESS") {
            // dispatch(getEmployeeList(token, pageNumber - 1, pageSize));
            handleClose();
            Swal.fire({
              title: "Success!",
              text: "User details submitted successfully.",
              icon: "success",
              timer: 2000,
              showConfirmButton: false,
            });
          } else {
            Swal.fire({
              title: "Error!",
              text: "User details submitted unsuccessfull",
              icon: "error",
              confirmButtonText: "OK",
            });
          }
        })
        .catch(() => {
          Swal.fire({
            title: "Error!",
            text: "There was an error submitting the user details.",
            icon: "error",
            confirmButtonText: "OK",
          });
        });
    }
  };

  const handleViewClick = async () => {
    const designation = desiglist.find(
      (desig) => desig.designationId === rowData.designationId);

    if (designation) setUserdesignation(designation.designationName);
    await Promise.all([
      dispatch(getUserByLoginId(rowData.loginId, token, EMP_USER_DETAILS)),
      dispatch(getPersonalDetails(rowData.loginId, token)),
      dispatch(getFamilyDetails(rowData.loginId, token)),
      dispatch(getEducationDetails(rowData.loginId, token)),
      dispatch(getExperienceDetails(rowData.loginId, token)),
      dispatch(getUserDocumentDetails(rowData.loginId, token)),
      dispatch(fetchClientDetails(token)),
    ]);
    setGeneratePdfFlag(true);
  }

  useEffect(() => {
    if (generatePdfFlag) {
      if (
        empUserDetails &&
        personalDetails &&
        familyListDetails &&
        educationListDetails &&
        experienceListDetails &&
        clientDetails
      ) {
        generatePDF(
          empUserDetails,
          personalDetails,
          familyListDetails,
          educationListDetails,
          experienceListDetails,
          clientDetails,
          userdesignation,
          userdocslist,
        );
        setGeneratePdfFlag(false);
      }
    }
  }, [
    empUserDetails,
    personalDetails,
    familyListDetails,
    educationListDetails,
    experienceListDetails,
    clientDetails,
    generatePdfFlag,
    generatePDF,
  ]);


  return (
    <div>
      <Navbar></Navbar>
      <div className="container cs-container">
        <div className="d-flex justify-content-end align-items-center mb-3">
          <div></div>
          {rowData.status === "A" && (<button
            className="btn btn-primary me-2 "
            onClick={handleViewClick}
          >
            PREVIEW PDF <FaFilePdf />
          </button>
          )}
          <button
            type="button"
            className="btn btn-secondary me-1 "
            onClick={() => window.history.back()}
          >
            BACK
          </button>
        </div>
        <div className="card3 shadow-lg border-0 stylish-card">
          <div className="stepper d-flex justify-content-between align-items-center mb-4">
            {/* Step 1 */}
            <div
              className={`step ${activeStep === 1 ? "active" : ""} ${(activeStep > 1 || rowData.status === "I" || rowData.status === "A" || customRowData.status === "I") ? "completed" : ""
                }`}
              onClick={() => handleStepClick(1)}
            >
              <div className="circle">1</div>
              <div className="label">New Hire Initiation</div>
              <div className="line"></div>
            </div>

            {/* Step 2 */}
            <div
              className={`step ${activeStep === 2 ? "active" : ""} ${(activeStep > 2 || offerDetails?.status === "Offer Accepted") ? "completed" : ""
                }`}
              onClick={() => {
                if (rowData.status === "I" || rowData.status === "A" || customRowData.status === "I") handleStepClick(2)
              }
              }
            >
              <div className="circle">2</div>
              <div className="label">Offer Generation</div>
              <div className="line"></div>
            </div>

            {/* Step 3 */}
            <div
              className={`step ${activeStep === 3 ? "active" : ""} ${(onBoardUserDetails?.empId || (isDataExists && !editMode)) ? "completed" : ""}`}
              onClick={() => {
                if (offerDetails?.status === "Offer Accepted") handleStepClick(3)
              }}
            >
              <div className="circle">3</div>
              <div className="label">On Boarding</div>
            </div>
          </div>


          {/* Stepper Content */}
          <div className="step-content">

            <div className="card-body stylish-card-body">
              {activeStep === 1 && rowData ? (
                <div>
                  <div className="table-responsive">
                    <h5 className="card-title text-primary text-center mt-3 mb-3">
                      User Details
                    </h5>
                    <table className="table table-bordered">
                      <thead>
                        <tr className="text-center">
                          <th className="tablecell text-white">Name</th>
                          <th className="tablecell text-white">Date of Birth</th>
                          <th className="tablecell text-white">PAN</th>
                          <th className="tablecell text-white">Email</th>
                          {(rowData.status === null || rowData.status !== "A") && (
                            <th className="tablecell text-white">
                              Action
                            </th>
                          )}
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td >{`${rowData.firstName} ${rowData.lastName}`}</td>
                          <td className="text-center">{formatDate(rowData.dob)}</td>
                          <td className="text-center">{rowData.pan}</td>
                          <td>{rowData.personalEmail} </td>
                          {(rowData.status === null || rowData.status !== "A") && (<td >
                            <Tooltip text="Edit">
                              <Icon
                                icon={FaEdit}
                                variant="warning"
                                className="ms-1"
                                onClick={() => handleEditUser()}
                              />
                            </Tooltip>
                          </td>
                          )}
                        </tr>
                      </tbody>
                    </table>
                  </div>

                  {rowData?.status !== "A" && (<div className="row">
                    <div className="col text-center mt-4">
                      <button
                        type="submit"
                        id="sbmtdata"
                        className="btn btn-primary"
                        onClick={handleSubmit}
                      >
                        {(rowData.status === "I" || customRowData.status === "I") ? "REINITIATE NEWHIRE " : "INITIATE NEWHIRE"}
                      </button>

                    </div>
                  </div>
                  )}
                  <div>
                    {newHireTransactionList && newHireTransactionList.length > 0 &&
                      <>
                        <h4>Initiation History</h4>
                        <table className="table table-bordered">
                          <thead>
                            <tr className="text-center">
                              <th className="tablecell text-white">SN</th>
                              <th className="tablecell text-white">Initiated Date</th>
                              <th className="tablecell text-white">Expired Date</th>
                              <th className="tablecell text-white">Action Date Time</th>
                            </tr>
                          </thead>
                          <tbody>
                            {newHireTransactionList.map((data, i) => (
                              <tr key={i} className="text-center">
                                <td>{i + 1}</td>
                                <td>{format(new Date(data.intiateDate), "dd-MM-yyyy")}</td>
                                <td>{format(new Date(data.expDate), "dd-MM-yyyy")}</td>
                                <td>{format(new Date(data.createdDate), "dd-MM-yyyy hh:mm a")}</td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </>
                    }
                  </div>
                </div>
              ) : activeStep === 1 && !rowData ? (
                <p>No data available</p>
              ) : null}

              {activeStep === 2 && (
                <div>
                  {isEditing && !editData ? (
                    <div className="table-responsive">
                      <h5 className="card-title text-center mt-3 mb-3 text-primary">
                        Offer Details
                      </h5>
                      <table className="table table-bordered">
                        <thead>
                          <tr>
                            <th className="tablecell text-white">Joining Date</th>
                            <th className="tablecell text-white">Offer Letter</th>
                            <th className="tablecell text-white">Status</th>
                            <th className="tablecell text-white">Preview</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td>{offerDetails.joiningDate}</td>
                            <td>{offerDetails.offerAttachmentFileName}</td>
                            <td>{offerDetails.status}</td>
                            <td>
                              <button
                                onClick={() =>
                                  handleDownload(
                                    offerDetails.offerAttachmentFileName,
                                    rowData.loginId
                                  )
                                }
                                className="no-border-button"
                              >
                                <FaDownload className="download-icon" />
                              </button>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                      {offerDetails?.status !== "Offer Accepted" && (<div className="text-center mt-4">
                        <button
                          type="button"
                          className="btn btn-warning me-2"
                          onClick={handleOfferModifyClick}
                        >
                          MODIFY
                        </button>
                      </div>
                      )}
                    </div>
                  ) : (
                    <form onSubmit={handleOfferSubmit}>
                      <h5
                        className={`card-title text-center mt-3 mb-3 ${isEditing ? "text-danger" : "text-success"
                          }`}
                      //  className="card-title text-success text-center mt-3 mb-3"
                      >
                        {isEditing ? "Revise Offer" : "Generate Offer"}
                      </h5>
                      <div className="row mb-3">
                        <div className="col-md-1"></div>
                        <div className="col-md-4">
                          <label htmlFor="joiningDate">
                            <strong>Joining Date:</strong>
                          </label>
                          <DatePicker
                            selected={joiningDate ? new Date(joiningDate) : null}
                            onChange={(date) => {
                              if (date) {
                                setJoiningDate(format(date, "yyyy-MM-dd"));
                              } else {
                                setJoiningDate("");
                              }
                            }}
                            className="form-control"
                            dateFormat="dd-MM-yyyy"
                            placeholderText="Joining Date"
                            showYearDropdown
                            showMonthDropdown
                            dropdownMode="select"
                            onKeyDown={(event) => event.preventDefault()}
                            required
                          />

                        </div>
                        <div className="col-md-4">
                          <label htmlFor="offerLetter">
                            <strong>Offer Letter:</strong>
                          </label>
                          <input
                            type="file"
                            className="form-control"
                            id="offerLetter"
                            onChange={handleFileChange}
                            required
                          />
                        </div>
                        <div className="col-md-2 d-flex align-items-end justify-content-center">
                          {isEditing ? (
                            <>
                              <button
                                type="submit"
                                className="btn btn-primary me-2"
                              >
                                REVISE
                              </button>
                              <button
                                type="button"
                                className="btn btn-secondary me-2"
                                onClick={handleOfferCancelClick}
                              >
                                CANCEL
                              </button>
                            </>
                          ) : (
                            <button type="submit" className="btn btn-primary" disabled={rowData.status == null || rowData.status === "I"}>
                              SUBMIT
                            </button>
                          )}
                        </div>
                        <div className="col-md-1"></div>
                      </div>
                      {/* <div className="col-md-2"></div> */}
                      {!isEditing && (
                        <div className="mt-5 d-flex justify-content-center">
                          <div
                            style={{
                              backgroundColor: "rgb(232 239 255)",
                              fontSize: "15px",
                              padding: "8px 16px",
                              borderRadius: "17px",
                              whiteSpace: "nowrap",
                            }}
                          >
                            <strong className="text-danger me-1">Status:</strong>
                            {rowData.status === "A" && (
                              <>
                                <span>
                                  The final submission has been completed by <strong>{onBoardUserDetails?.firstName}</strong>.You may proceed with offer generation.
                                </span>
                              </>
                            )}
                            {(rowData.status === null || rowData.status === "I") && (
                              <>
                                <span>
                                  The final submission from <strong>{onBoardUserDetails?.firstName}</strong> is still pending. Offer generation is currently disabled.
                                </span>
                              </>
                            )}
                          </div>
                        </div>
                      )}

                    </form>
                  )}
                </div>
              )}

              {activeStep === 3 && (
                <div>
                  {isDataExists && !editMode ? (
                    // Table format for read-only view
                    <div className="table-responsive">
                      <h5 className="card-title text-center mt-3 mb-3 text-primary">
                        Onboarding Details
                      </h5>
                      <table className="table table-bordered">
                        <thead>
                          <tr>
                            <th className="tablecell text-white">Joining Date</th>
                            <th className="tablecell text-white">Employee ID</th>
                            <th className="tablecell text-white">Office Mail</th>
                            <th className="tablecell text-white">Manager</th>
                            <th className="tablecell text-white">HR</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td>{formatDate(onboardData.joiningDate)}</td>
                            <td>{onboardData.empId}</td>
                            <td>{onboardData.officeEmail}</td>
                            <td>
                              {
                                emplists.find(
                                  (emp) => emp.loginId === onboardData.managerId
                                )?.firstName
                              }{" "}
                              {
                                emplists.find(
                                  (emp) => emp.loginId === onboardData.managerId
                                )?.lastName
                              }
                            </td>
                            <td>
                              {
                                emplists.find(
                                  (emp) => emp.loginId === onboardData.hrId
                                )?.firstName
                              }{" "}
                              {
                                emplists.find(
                                  (emp) => emp.loginId === onboardData.hrId
                                )?.lastName
                              }
                            </td>
                          </tr>
                        </tbody>
                      </table>
                      <div className="text-center mt-4">
                        <button
                          type="button"
                          className="btn btn-warning me-2"
                          onClick={handleModifyClick}
                        >
                          MODIFY
                        </button>
                        <button
                          type="button"
                          className="btn btn-success me-2"
                          onClick={viewModal}
                        >
                          APPROVE
                        </button>
                      </div>
                    </div>
                  ) : (
                    // Form for adding or revising onboarding data
                    <div>
                      <h5
                        className={`card-title text-center mt-3 mb-3 ${isDataExists ? "text-danger" : "text-success"
                          }`}
                      >
                        {isDataExists ? "Revise Onboarding" : "Add Onboarding"}
                      </h5>
                      <form onSubmit={handleOnboardSubmit}>
                        <div className="row mb-3">
                          <div className="col-md-4">
                            <label htmlFor="joiningDate" className="form-label">
                              <strong>Joining Date</strong>
                            </label>
                            <DatePicker
                              selected={onboardData.joiningDate ? new Date(onboardData.joiningDate) : null}
                              onChange={(date) => {
                                handleInputChange({
                                  target: {
                                    id: "joiningDate",
                                    value: date ? format(date, "yyyy-MM-dd") : "",
                                  },
                                });
                              }}
                              className="form-control"
                              dateFormat="dd-MM-yyyy"
                              placeholderText="Joining Date"
                              showYearDropdown
                              showMonthDropdown
                              dropdownMode="select"
                              onKeyDown={(event) => event.preventDefault()}
                              required
                            />
                          </div>
                          <div className="col-md-4">
                            <label htmlFor="empId" className="form-label">
                              <strong>Employee ID</strong>
                            </label>
                            <input
                              type="text"
                              className="form-control"
                              id="empId"
                              placeholder="Enter Employee ID"
                              value={onboardData.empId}
                              onChange={handleInputChange}
                              required
                            />
                          </div>
                          <div className="col-md-4">
                            <label htmlFor="officeEmail" className="form-label">
                              <strong>Official Email</strong>
                            </label>
                            <input
                              type="email"
                              className="form-control"
                              id="officeEmail"
                              placeholder="Enter Official Email"
                              value={onboardData.officeEmail}
                              onChange={handleInputChange}
                              required
                            />
                          </div>
                        </div>
                        <div className="row mb-3">
                          <div className="col-md-4">
                            <label htmlFor="managerId" className="form-label">
                              <strong>Manager</strong>
                            </label>
                            <select
                              className="form-select"
                              id="managerId"
                              value={onboardData.managerId}
                              onChange={handleInputChange}
                              required
                            >
                              <option value="">Select Manager</option>
                              {emplists.map((manager, index) => (
                                <option key={index} value={manager.loginId}>
                                  {manager?.firstName || ""} {manager?.lastName || ""}
                                </option>
                              ))}
                            </select>
                          </div>
                          <div className="col-md-4">
                            <label htmlFor="hrId" className="form-label">
                              <strong>HR</strong>
                            </label>
                            <select
                              className="form-select"
                              id="hrId"
                              value={onboardData.hrId}
                              onChange={handleInputChange}
                              required
                            >
                              <option value="">Select HR</option>
                              {emplists.map((hr, index) => (
                                <option key={index} value={hr.loginId}>
                                  {hr?.firstName || ""} {hr?.lastName || ""}
                                </option>
                              ))}
                            </select>
                          </div>
                        </div>
                        <div className="row">
                          <div className="col text-center mt-4">
                            {isDataExists ? (
                              <>
                                <button
                                  type="submit"
                                  className="btn btn-primary me-2"
                                >
                                  UPDATE
                                </button>
                                <button
                                  type="button"
                                  className="btn btn-secondary me-2"
                                  onClick={handleCancelClick}
                                >
                                  CANCEL
                                </button>
                              </>
                            ) : (
                              <button type="submit" className="btn btn-primary">
                                SUBMIT
                              </button>
                            )}
                          </div>
                        </div>
                      </form>
                    </div>
                  )}
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
      {show && (
        <>
          <div className="modal-backdrop fade show"></div>
          <div
            className="modal fade newhire-modal show"
            tabIndex="-1"
            role="dialog"
            style={{ display: "block" }}
          >
            <div
              className="modal-dialog modal-lg modal-dialog-centered"
              role="document"
            >
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title">
                    {userData.actionType === "INSERT"
                      ? "Create User"
                      : "Edit User"}
                  </h5>
                  <button
                    type="button"
                    className="btn-close"
                    onClick={handleClose}
                  ></button>
                </div>
                <div className="modal-body">
                  <form onSubmit={handleUserEditSubmit}>
                    <div className="row">
                      <div className="col-12 col-md-6">
                        <div className="mb-3">
                          <label className="form-label">
                            <b>First Name</b>
                            <span className="text-danger">*</span>
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            required
                            maxLength="100"
                            name="firstName"
                            value={userData.firstName || ""}
                            onChange={handleChange}
                          />
                        </div>
                      </div>
                      <div className="col-12 col-md-6">
                        <div className="mb-3">
                          <label className="form-label">
                            <b>Last Name</b>
                            <span className="text-danger">*</span>
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            required
                            maxLength="100"
                            name="lastName"
                            value={userData.lastName || ""}
                            onChange={handleChange}
                          />
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-12 col-md-6">
                        <div className="mb-3">
                          <label className="form-label">
                            <b>Email Id</b>
                            <span className="text-danger">*</span>
                          </label>
                          <input
                            type="email"
                            className="form-control"
                            required
                            maxLength="100"
                            name="personalEmail"
                            value={userData.personalEmail || ""}
                            onChange={handleChange}
                          />
                          {emailValidationMessage && (
                            <div className="text-danger">
                              {emailValidationMessage}
                            </div>
                          )}
                        </div>
                      </div>
                      <div className="col-12 col-md-6">
                        <div className="mb-3">
                          <label className="form-label">
                            <b>D.O.B</b>
                            <span className="text-danger">*</span>
                          </label>
                          <DatePicker
                            selected={userData.dateOfBirth ? new Date(userData.dateOfBirth) : null}
                            onChange={(date) => handleDateChange(date, "dateOfBirth")}
                            className="form-control"
                            dateFormat="dd-MM-yyyy"
                            placeholderText="Date Of Birth"
                            showYearDropdown
                            showMonthDropdown
                            dropdownMode="select"
                            onKeyDown={(event) => event.preventDefault()}
                            maxDate={new Date()}
                            required
                          />
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-12 col-md-6">
                        <div className="mb-3">
                          <label className="form-label">
                            <b>PAN</b>
                            <span className="text-danger">*</span>
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            required
                            maxLength="10"
                            minLength="10"
                            name="pan"
                            value={userData.pan || ""}
                            onChange={handleChange}
                            style={{ textTransform: "uppercase" }}
                          />
                          {panValidationMessage && (
                            <div className="text-danger">
                              {panValidationMessage}
                            </div>
                          )}
                        </div>
                      </div>
                      <div className="col-12 col-md-6">
                        <div className="mb-3">
                          <label className="form-label">
                            <b>Role</b>
                            <span className="text-danger">*</span>
                          </label>
                          <select
                            className="form-select"
                            required
                            name="role"
                            value={userData.role || ""}
                            onChange={handleChange}
                          >
                            <option value="">Select Role</option>
                            {rolelists &&
                              rolelists.map((role, index) => (
                                <option key={index} value={role.roleId}>
                                  {role.roleName}
                                </option>
                              ))}
                          </select>
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-12 col-md-6">
                        <div className="mb-3">
                          <label className="form-label">
                            <b>Designation</b>
                            <span className="text-danger">*</span>
                          </label>
                          <select
                            className="form-select"
                            required
                            name="designation"
                            value={userData.designation || ""}
                            onChange={handleChange}
                          >
                            <option value="">Select Designation</option>
                            {desiglist &&
                              desiglist.map((designation, index) => (
                                <option
                                  key={index}
                                  value={designation.designationId}
                                >
                                  {designation.designationName}
                                </option>
                              ))}
                          </select>
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col text-center mt-3">
                        <button
                          type="submit"
                          id="sbmtdata"
                          className="btn btn-primary"
                          disabled={!submitEnabled}
                        >
                          {userData.actionType === "UPDATE"
                            ? "UPDATE"
                            : "SUBMIT"}
                        </button>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </>
      )}
      {roleModal && (
        <>
          <div className="modal-backdrop fade show"></div>
          <div
            className="modal fade newhire-modal show"
            tabIndex="-1"
            role="dialog"
            aria-modal="true"
            aria-labelledby="roleModalLabel"
            style={{ display: "block" }}
          >
            <div className="modal-dialog modal-md modal-dialog-centered" role="document">
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title" id="roleModalLabel">
                    Select Role
                  </h5>
                  <button type="button" className="btn-close" onClick={handleCloseRoleModal}></button>
                </div>
                <div className="modal-body">
                  <div className="mb-3">
                    <form onSubmit={handleApprove}>
                      <div>
                        <label className="form-label">
                          <b>Role</b> <span className="text-danger">*</span>
                        </label>
                        <select
                          className="form-select"
                          required
                          name="role"
                          value={selectedRoleName}
                          onChange={(e) => {
                            const selectedId = e.target.value;
                            setSelectedRoleName(selectedId);

                          }}
                        >
                          <option value="">Select Role..</option>
                          {rolelists
                            ?.filter((role) =>
                              ["ROLE_EMP", "ROLE_CONTRACT", "ROLE_SUPPORT"].includes(role.roleName)
                            )
                            .map((role, index) => (
                              <option key={index} value={role.roleName}>
                                {role.roleName}
                              </option>
                            ))}
                        </select>

                      </div>
                      <div className="row">
                        <div className="col text-center mt-5">
                          <button
                            type="submit"
                            id="sbmtdata"
                            className="btn btn-primary"
                          >
                            SUBMIT
                          </button>
                        </div>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </>
      )}

    </div>
  );
};

export default OnBoarding;
